import { KatAlert } from "@amzn/katal-react";
import classnames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import React, { type FC, useEffect, useState } from "react";
import styles from "./styles.module.scss";

export interface AlertProps {
  description?: string;
  header?: string;
  variant: KatAlert.Variant;
  fade?: boolean;
}

const FADE_TIMEOUT = 5000;

const AlertItem: FC<AlertProps> = ({
  description,
  header,
  variant,
  fade = false,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (fade) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, FADE_TIMEOUT);
      return () => clearTimeout(timer);
    }
  }, [fade]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: FADE_TIMEOUT / 10000 }}
          className={classnames(
            styles.alert_default_style,
            styles.alert_static_style
          )}
        >
          <KatAlert
            description={description}
            header={header}
            variant={variant}
            persistent
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AlertItem;
